import { useSearchParams } from 'react-router-dom'
import { AuthLayout } from '../auth-layout/auth-layout'
import styles from './not-authorized-page.module.scss'

const COPY: Record<string, { heading: string; body: string }> = {
  non_admin: {
    heading: "You're signed in, but this dashboard is admin-only.",
    body: 'Your Slack account is recognised. Ask Corey to grant admin access if you need to be here.',
  },
  unknown: {
    heading: "We don't have a Politech profile for this Slack account yet.",
    body: 'The check-in bot will create one the next time you respond to a Slack prompt. Try signing in again afterward.',
  },
  inactive: {
    heading: 'This admin account is marked inactive.',
    body: 'Reach out to Corey to reactivate it.',
  },
  exchange_failed: {
    heading: 'Something went wrong talking to Slack.',
    body: 'Try signing in again in a minute. If it keeps happening, ping Corey.',
  },
  denied: {
    heading: 'Sign-in cancelled.',
    body: 'Click below to try again.',
  },
  oauth_unconfigured: {
    heading: 'Sign in with Slack is not set up yet.',
    body: 'Set SLACK_CLIENT_ID and SLACK_CLIENT_SECRET in the Render dashboard, then redeploy.',
  },
}

const FALLBACK = {
  heading: "You don't have access to this dashboard.",
  body: 'Contact Corey if you think this is wrong.',
}

export function NotAuthorizedPage() {
  const [params] = useSearchParams()
  const reason = params.get('reason') ?? ''
  const copy = COPY[reason] ?? FALLBACK

  return (
    <AuthLayout>
      <h1 className={styles.heading}>{copy.heading}</h1>
      <p className={styles.body}>{copy.body}</p>
      <a href="/auth/slack" className={styles.action}>
        Try signing in again
      </a>
    </AuthLayout>
  )
}
